/* global jQuery */
import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { AnchorLink } from '../common'
import * as utils from '../../lib/utils/common'

export class GlobalNavTertiary extends React.Component {

  constructor(props) {
    super(props)
    this._initNav = this._initNav.bind(this)
    this._toggleMoreLinks = this._toggleMoreLinks.bind(this)
    this._hideMoreLinks = this._hideMoreLinks.bind(this)
    this._setSubContentHeight = this._setSubContentHeight.bind(this)

    // by default more links are hidden
    this.state = {
      showMoreLinks : false
    }
  }

  static propTypes = {
    links: PropTypes.array.isRequired,
    activeKey: PropTypes.string.isRequired
  }

  componentDidMount() {
    // keep the ref of throttled Fn
    this._handleResize = utils.throttle(this._initNav, 150).bind(this)

    try {
      jQuery(window).on('resize orientationchange', this._handleResize)
      this._initNav()
    } catch(err) {
      console.error(err)
    }
  }

  componentWillUnmount() {
    jQuery(window).off('resize orientationchange', this._handleResize)
  }

  componentWillReceiveProps() {
    const linksCount = this.props.links.length

    // reset the state of visibleCount & linksCount
    this.setState({
      visibleCount : linksCount,
      linksCount,
      isReset : true
    })
  }

  componentDidUpdate(prevProps) {
    try {
      jQuery('.sub a[data-linktype='+this.props.activeKey+']').parent().addClass('active')
    } catch(err) {
      console.error(err)
    }
    
    // re-init only if previous props and current props are diff
    if (prevProps !== this.props) {
      this._initNav()
    }
  }

  /**
   * init Navigation
   * @return {undefined}
   */
  _initNav() {
    const { navContainer } = this.refs

    // no init if the nav is hidden
    if (jQuery(navContainer).is(':hidden')) {
      return
    }

    let visibleCount
    const { linksCount } = this.state
    const deviceType = utils.deviceType()

    this._resetNav()

    // scrollable nav if device is mobile with touch
    if (deviceType.isMobile && deviceType.isTouch) {
      visibleCount = linksCount
    } 
    /*
     * display more-button if device is not mobile
     * or no touch
     */
    else {
      visibleCount = this._getVisibleCount()

      // hide the more links on resize if all links visible
      if (visibleCount === linksCount) {
        this._hideMoreLinks()
      }
    }     

    this.setState({
      visibleCount,
      isReset : false
    })
  }

  /**
   * reset the naviagation and
   * make all the links and more button visible
   * @return {undefined}
   */
  _resetNav() {
    let { linksCount } = this.state

    this.setState({
      visibleCount: linksCount,
      isReset : true
    })
  }

  /**
   * Event Handler
   * hide more links and remove scroll-lock
   * @return {undefined}
   */
  _hideMoreLinks() {
    this.setState({
      showMoreLinks: false
    })

    this._scrollLock(false)
  }

  /**
   * Event Handler
   * toggle the more links show/hide
   * @return {undefined} [description]
   */
  _toggleMoreLinks() {
    let { showMoreLinks } = this.state

    showMoreLinks = !showMoreLinks

    this.setState({
      showMoreLinks
    })

    this._scrollLock(showMoreLinks)

    return false
  }

  /**
   * lock scroll bar
   * @param  {Boolean} shouldLock - on/off flag
   * @return {undefined}
   */
  _scrollLock(shouldLock = false) {
    if (typeof utils.scrollLock === 'function') {
      utils.scrollLock(shouldLock)
    }
  }

  /**
   * set the height of sub-content
   * @return {undefined}
   */
  _setSubContentHeight() {
    const { subContent, navWrap } = this.refs
    const deviceType = utils.deviceType()
    let height

    if (typeof subContent === 'undefined' ||
        typeof navWrap === 'undefined') {
      return
    }

    if (deviceType.isTablet || (deviceType.isMobile && !deviceType.isTouch)) {
      const windowHeight = jQuery(window).outerHeight()
      const navWrap$ = jQuery(navWrap)
      const navWrapHeight = navWrap$.outerHeight()
      const navWrapOffsetY = navWrap$.offset().top

      height = (windowHeight - navWrapOffsetY - navWrapHeight) + 'px'
    } else {
      height = '0px'
    }

    subContent.style.minHeight = height 
  }

  /**
   * calculate the visible links
   * @return {Number}   - count of visible links
   */
  _getVisibleCount() {
    const { firstGroup, navContainer } = this.refs
    const { spacerId = '' } = this.props
    const spacerWidth = jQuery('#' + spacerId).width()
    const firstGroup$ = jQuery(firstGroup)
    const lis = firstGroup$.find('li.sub')
    const containerWidth = jQuery(navContainer).width() - spacerWidth

    // total width of 'more' button (including margin)
    const moreButtonWidth = firstGroup$.find('.has-sub').outerWidth(true)

    // intial to '0'
    let maxVisibleLinks = 0

    // init with 'more' button width + 50px gutter space
    let totalWidth = moreButtonWidth + 50

    for(let i =0, len=lis.length; i < len; i++) {
      let outerWidth = jQuery(lis[i]).outerWidth(true)
      if( totalWidth + outerWidth > containerWidth ) {
        break
      }else{
        maxVisibleLinks++
        totalWidth += outerWidth
      }
    }

    return maxVisibleLinks
  }

  /**
   * build nav links
   * @param  {Array} options.links      links
   * @param  {String} options.activeKey activeKey
   * @param  {String} options.keyProp   key prop to check active link
   * @return {Array}                    Array of React elements of links
   */
  _buildLinks({ links, activeKey, keyProp = 'pageType' }) {
    const { showMoreLinks } = this.state

    return links.map((link, i) => {
      // mark active if more links is hidden and match the pageType
      const liClass = classnames('sub',{ active: !showMoreLinks && activeKey == link[keyProp] })
      let anchorClass = classnames(link.pageType, link.external )
      /**
       * By default, all links on tertiary nav are handled by react router
       * If link is external, set to false. Anchor component will not add class
       * which specifies that this is react router link.
       */
      let isRouterLink = typeof link.isRouterLink === 'boolean' ? link.isRouterLink : true
      // external links need to open in new window
      let linkTarget = {}
      if (link.external) {
        isRouterLink = false
        linkTarget.target= '_blank'
      }
      const text = [
        <span key="t" className="link-text">{link.text}</span>,
        <span key="st" className="link-text-short">{link.text}</span>
      ]
      return (
        <li key={i} className={liClass}>
          <AnchorLink trackingName={link.trackingName} {...linkTarget} data-linktype={link.pageType || ''} classes={anchorClass} text={text} to={link.href} onClick={this._hideMoreLinks} isRouterLink={isRouterLink}/>
        </li>
      )
    })
  }

  render() {
    const deviceType = utils.deviceType()
    const { links = [], activeKey = '' } = this.props
    const { visibleCount, linksCount, showMoreLinks, isReset } = this.state
    const overlayClass = classnames('more-overlay-primary',
      { 'active': showMoreLinks && (deviceType.isTablet || (deviceType.isMobile && !deviceType.isTouch)) }
    )
    const moreLiClass = classnames('has-sub',{ 'show hover': showMoreLinks })

    let visibleLinks = this._buildLinks({ links, activeKey })
    let moreLinks = []

    if (visibleCount !== linksCount) {
      moreLinks = visibleLinks.slice(visibleCount)
      visibleLinks = visibleLinks.slice(0, visibleCount)
    }

    return (
      <div id="gamepackage-links-wrap" ref="navWrap">
        <div className={overlayClass}></div>
        <nav id="global-nav-tertiary" className="game-package-nav" style={{ display : 'block' }}>
          <div className="tertiary-nav-container" style={ { 'overflow':'visible' } } ref="navContainer">
            <ul className="first-group" ref="firstGroup" style={ { 'overflow': (showMoreLinks ?'visible':'') } }>
              {visibleLinks}

              { !(isReset || moreLinks.length) ? '' :
                <li className={moreLiClass} onClick={this._toggleMoreLinks} onMouseEnter={this._setSubContentHeight}>
                  <a className="more-link" data-route="false">
                      <span className="link-text">More</span>
                      <span className="link-text-short">More</span>
                  </a>
                  <div className="sub-content" style={{ 'top':'100%' }} ref="subContent">
                    <ul className="split">
                      {moreLinks}
                    </ul>
                  </div>
                </li>
              }
            </ul>
          </div>
        </nav>
      </div>
    )
  }

}

export default GlobalNavTertiary



// WEBPACK FOOTER //
// ../app/components/gamepackage/GlobalNavTertiary.jsx